import "core-js/modules/es.array.find";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Role } from '@/interfaces/user';

var AuthFilter = /*#__PURE__*/function (_Vue) {
  _inherits(AuthFilter, _Vue);

  var _super = _createSuper(AuthFilter);

  function AuthFilter() {
    var _this;

    _classCallCheck(this, AuthFilter);

    _this = _super.apply(this, arguments);
    _this.Role = Role;
    return _this;
  }

  _createClass(AuthFilter, [{
    key: "getRole",
    value: function getRole() {
      if (!this.me) {
        return false;
      }

      var role = this.me.role;

      switch (role) {
        case Role.ROOT:
          return 'root';

        case Role.ADMIN:
          return 'admin';

        case Role.DEALER:
          return 'dealer';

        default:
          return false;
      }
    }
  }, {
    key: "rolesGuard",
    value: function rolesGuard(roles) {
      var me = this.me;
      var privilege = roles.find(function (role) {
        return me.role === role;
      });

      if (!privilege || !me) {
        return false;
      } else {
        return true;
      }
    }
  }]);

  return AuthFilter;
}(Vue);

__decorate([State(function (state) {
  return state.user.me;
})], AuthFilter.prototype, "me", void 0);

AuthFilter = __decorate([Component], AuthFilter);
export default AuthFilter;